import { render, staticRenderFns } from "./ScholarshipStudentPaymentsStatus.vue?vue&type=template&id=38cc7093&"
import script from "./ScholarshipStudentPaymentsStatus.vue?vue&type=script&lang=js&"
export * from "./ScholarshipStudentPaymentsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports